const getFlowsGuid = state => state.automationTab.flows.guid;
export default getFlowsGuid;